import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { CreateFundingSourceDrawer } from '../../../../../../features/funding/source/create-funding-source-drawer';
import { FundingSourcesTable } from '../../../../../../features/funding/source/funding-sources-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/funding/source/_source/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RollupFunding,
      label: 'Sources',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RollupFunding>,
  head: () => getPageHead('Funding Sources'),
  component: FundingSourceList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateFundingSourceDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Source" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RollupFunding}
    />
  );
}

function FundingSourceList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FundingSourcesTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
